const module = { name: 'shared/global/responsiveAds', exports: {} }; const exports = module.exports;



import { mps as mps_onLoad } from 'require-global';

const { onLoad } = mps_onLoad;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



const Selectors = {
    ADS: '.js-ad',
}


const Styles = {
    HIDE_BG: 'ad-placement--hide-bg'
}


const mediaRules = {
    desktop: window.matchMedia('(min-width: 1025px)'),
    tablet: window.matchMedia('(max-width: 1024px)')
}


let currentMedia


let recheck = 0
function togglePlaceholders($ads) {
    if (recheck === 6) {
        recheck = 0;
        return;
    }
    if (recheck > 0) {
        $ads.each((index, el) => {
            const $el = $(el);
            const hide = $el.children().length > 0;
            $el.toggleClass(Styles.HIDE_BG, hide);
        });
    }
    recheck++;
    setTimeout(togglePlaceholders.bind(this, $ads), 500);
}
function getCurrentMedia() {
    return Object.keys(mediaRules).filter(key => mediaRules[key].matches)[0];
}
function updateResponsiveAds($ads, getAd) {
    togglePlaceholders($ads);
    $ads.each((index, el) => {
        const $ad = $(el);
        const media = $ad.data('media');
        if (typeof media !== 'string') {
            debugLog.error(module.name, 'no media data attribute found on ad');
            return;
        }
        const html = media.split(',').indexOf(currentMedia) !== -1 ? getAd($ad.data('slot')) : '';
        if (html) {
            debugLog.info(module.name, 'updating');
        }
        $ad.html(html);
    });
}
function doRefresh($ads, refreshAds, getAd) {
    const newMedia = getCurrentMedia();
    if (currentMedia === newMedia) {
        return;
    }
    debugLog.info(module.name, 'refresh for', newMedia);
    currentMedia = newMedia;
    $ads.html('').addClass(Styles.HIDE_BG);
    refreshAds();
    updateResponsiveAds($ads, getAd);
}
function onMPSReady({ getAd, isAvailable, refreshAds }) {
    if (!isAvailable) {
        return;
    }
    const $responsiveAds = $(Selectors.ADS).filter((index, el) => el.dataset.media);
    const refresh = doRefresh.bind(this, $responsiveAds, refreshAds, getAd);
    Object.keys(mediaRules).forEach(key => mediaRules[key].addListener(refresh));
    currentMedia = getCurrentMedia();
    updateResponsiveAds($responsiveAds, getAd);
}
module.exports = {
    init() {
        onLoad(onMPSReady);
    }
};
export default module.exports;